// 额度功能相关数据
export default {
  state: {
    residualQuota: 0, // 额度金额
    goodsAmt: 0, // 套餐自带的价格
    ifSupportQuota: 0, // 是否支持额度, 1 支持
    ifFamilySupportQuota: 0, // 家属是否支持额度
    fromPage: '' // 代表那个页面进预约流程的，my - 员工， family - 家属
  },
  mutations: {
    // 设置额度金额
    SET_RESIDUAL_QUOTA (state, residualQuota) {
      state.residualQuota = residualQuota
    },
    // 设置套餐自带的价格
    SET_GOODS_AMT (state, goodsAmt) {
      state.goodsAmt = goodsAmt
    },
    // 设置是否展示额度相关信息
    SET_SUPPORT_QUOTA (state, SupportQuota) {
      state.ifSupportQuota = SupportQuota
    },
    // 设置家属是否支持额度
    SET_FAMILY_SUPPORT_QUOTA (state, ifFamilySupportQuota) {
      state.ifFamilySupportQuota= ifFamilySupportQuota
    },
    // 这是预约流程的入口
    SET_FROM_PAGE (state, fromPage) {
      state.fromPage= fromPage
    }
  },
  getters: {
    // 获取剩余的可用额度金额
    GET_RESIDUAL_QUOTA (state) {
      const amount = state.residualQuota - state.goodsAmt
      // 额度用完 置为0
      return ((amount >= 0 ? amount : 0) / 1000).toFixed(2)
    },
    // 获取抵扣金额
    GET_DEDUCTION (state) {
      const { goodsAmt, residualQuota } = state
      // 抵扣金额用完则抵扣金额就是额度，否则就是所有的金额
      return ((residualQuota - goodsAmt >= 0 ? goodsAmt : residualQuota) / 1000).toFixed(2)
    },
    // 获取实付金额
    GET_PAID_AMOUNT (state) {
      // 额度金额 够用的，不需要实付
      if (state.residualQuota > state.goodsAmt) {
        return (0).toFixed(2)
      } else { // 额度金额不够用了 需要实付
        return ((state.goodsAmt - state.residualQuota) / 1000).toFixed(2)
      }
    },
    // 判断是否展示额度相关的数据
    SHOW_SUPPORT_QUOTA (state) {
      // 是家属 判断家属预约流程是否展示额度
      if(state.fromPage === 'family') {
        return +state.ifFamilySupportQuota === 1
      }else if(state.fromPage === 'my'){
        return +state.ifSupportQuota === 1
      }

      return false
    },
    // 判断家属是否展示额度
    SHOW_FAMILY_SUPPORT_QUOTA (state) {
      return +state.ifFamilySupportQuota === 1
    },
    // 判断是不是家属页面进入预约流程
    IS_FAMILY_PAGE (state) {
      return state.fromPage === 'family'
    }
  }
}
